"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _overrides = require("../../../utils/overrides");

var _Form = _interopRequireDefault(require("../../forms/Form"));

var _FieldControl = _interopRequireDefault(require("../Form/FieldControl"));

var _Icon = _interopRequireDefault(require("../../general/Icon"));

var _styles = require("../../../utils/styles");

var _styles2 = _interopRequireDefault(require("./styles"));

var useStyles = (0, _styles.createUseStyles)(_styles2.default, 'MultiplierControl');

function MultiplierControl(_ref) {
  var classesProp = _ref.classes,
      overridesProp = _ref.overrides,
      classNameProp = _ref.className,
      index = _ref.index,
      type = _ref.type,
      schema = _ref.schema,
      labelMode = _ref.labelMode,
      isFullWidth = _ref.isFullWidth,
      isReadOnly = _ref.isReadOnly,
      values = _ref.values,
      errors = _ref.errors,
      customFields = _ref.customFields,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      onRemove = _ref.onRemove,
      removeIconClassName = _ref.removeIconClassName,
      props = (0, _objectWithoutProperties2.default)(_ref, ["classes", "overrides", "className", "index", "type", "schema", "labelMode", "isFullWidth", "isReadOnly", "values", "errors", "customFields", "onChange", "onFocus", "onBlur", "onRemove", "removeIconClassName"]);
  var classes = (0, _overrides.useClasses)(useStyles, classesProp); // Overrides

  var override = (0, _overrides.getOverrides)(overridesProp, MultiplierControl.overrides); // Classes

  var removeIconClasses = (0, _classnames2.default)(removeIconClassName, (0, _defineProperty2.default)({}, classes.removeIconVertical, labelMode === 'vertical'));
  var onChangeMultiplier = (0, _react.useCallback)(function (value) {
    onChange && onChange(value, schema, index);
  }, [onChange, schema, index]);
  var onClickRemove = (0, _react.useCallback)(function () {
    onRemove(schema, index);
  }, [onRemove, schema, index]);
  var component;

  if (type === 'form') {
    component = /*#__PURE__*/_react.default.createElement(_Form.default, (0, _extends2.default)({
      className: classes.form,
      overrides: overridesProp,
      schema: schema,
      values: values,
      errors: errors,
      onChange: onChangeMultiplier,
      onFocus: onFocus,
      onBlur: onBlur,
      isFullWidth: isFullWidth,
      isReadOnly: isReadOnly,
      labelMode: labelMode,
      customFields: customFields
    }, override.Form, {
      override: override.Form,
      useNativeForm: false
    }));
  } else if (type === 'field') {
    var field = (0, _extends2.default)({}, schema);
    field.label = index === 0 ? field.label : '';
    component = /*#__PURE__*/_react.default.createElement(_FieldControl.default, (0, _extends2.default)({
      labelMode: labelMode,
      isFullWidth: isFullWidth,
      isReadOnly: isReadOnly,
      field: field,
      value: values,
      error: errors,
      onChange: onChangeMultiplier,
      onFocus: onFocus,
      onBlur: onBlur,
      customFields: customFields
    }, override.fieldControl));
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: classNameProp
  }, component, isReadOnly !== true && onRemove && /*#__PURE__*/_react.default.createElement(_Icon.default, (0, _extends2.default)({
    onClick: onClickRemove,
    className: removeIconClasses
  }, override.removeIcon, {
    name: "trash"
  })));
}

MultiplierControl.overrides = ['Form', 'fieldControl', 'removeIcon'];
MultiplierControl.defaultProps = {
  labelMode: 'horizontal',
  isFullWidth: false
};
process.env.NODE_ENV !== "production" ? MultiplierControl.propTypes = {
  /** Native form class */
  index: _propTypes.default.number,
  type: _propTypes.default.string,
  schema: _propTypes.default.any,
  labelMode: _propTypes.default.string,
  isFullWidth: _propTypes.default.bool,
  isReadOnly: _propTypes.default.bool,
  values: _propTypes.default.any,
  errors: _propTypes.default.any,
  multiplierItemClassNames: _propTypes.default.any
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(MultiplierControl);

exports.default = _default;